import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/Images/icono-realtor.png'


const _hoisted_1 = { class: "text-left no-printable" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]"
}
const _hoisted_4 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "btn-list-users tw-flex tw-justify-end tw-mb-4" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn tw-flex tw-items-center tw-text-[#FFFFFF] tw-bg-[#00A0DA] tw-rounded-full",
    "data-bs-toggle": "modal",
    "data-bs-target": "#exampleModalUsers"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users tw-text-[#FFFFFF] tw-text-[30px] tw-pr-3" }),
    /*#__PURE__*/_createTextVNode(" SEE ECONOMIC SHEET ")
  ])
], -1)
const _hoisted_6 = {
  class: "modal fade modal-xl",
  id: "exampleModalUsers",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "modal-dialog" }
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = { class: "modal-header" }
const _hoisted_10 = {
  key: 0,
  class: "comment-box"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "\"Action.\"", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "\"Watch Scenario.\"", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close custom-close-button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
], -1)
const _hoisted_15 = { class: "modal-body" }
const _hoisted_16 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_17 = { class: "tw-flex tw-gap-3" }
const _hoisted_18 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Name", -1)
const _hoisted_20 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PhoneNumber", -1)
const _hoisted_22 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Date", -1)
const _hoisted_24 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PHONE NUMBER"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CREATION DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTION")
  ])
], -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  class: "modal fade modal-xl",
  id: "exampleModal4858",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel4858",
  "aria-hidden": "true"
}
const _hoisted_34 = { class: "modal-dialog" }
const _hoisted_35 = { class: "modal-content" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = { class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-" }
const _hoisted_39 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_40 = { class: "tw-flex tw-justify-start gap-3 tw-w-full" }
const _hoisted_41 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_42 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CODE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SECTION"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCENARIO"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "WATCH SCENARIO")
  ])
], -1)
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "4",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-center tw-text-lg tw-text-[20px] tw-border-b-[2px] tw-border-[#b0b0b0] tw-pb-2" }, " SHORT TERM FINANCING INVESTMENT", -1)
const _hoisted_53 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-5 tw-mt-3" }
const _hoisted_54 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExampleFlipTittle",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("b", null, "TITLE COMPANY     ▼")
], -1)
const _hoisted_56 = {
  class: "collapse",
  id: "collapseExampleFlipTittle"
}
const _hoisted_57 = { class: "card card-body tw-px-[80px]" }
const _hoisted_58 = {
  class: "tw-px-[30px]",
  style: {"border":"1px solid #b0b0b0"}
}
const _hoisted_59 = { class: "tw-flex tw-justify-around mt-3 mb-3" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = { class: "pb-3" }
const _hoisted_62 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CLOSING CLOSE"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "OTHER PRICE")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, "BUYER"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, "SELLER"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, [
      /*#__PURE__*/_createTextVNode("SEARCH TITLE "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" COMPANY")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "1"
    }, "CHAIN TITTLE")
  ])
], -1)
const _hoisted_64 = {
  key: 0,
  class: "data"
}
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExample88",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("b", null, "INSPECTOR     ▼")
], -1)
const _hoisted_68 = {
  class: "collapse",
  id: "collapseExample88"
}
const _hoisted_69 = { class: "card card-body" }
const _hoisted_70 = { class: "tw-flex tw-justify-around" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("button", { class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]" }, "GET IT", -1)
const _hoisted_73 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " MORTGAGE LOAN ORIGINATOR", -1)
const _hoisted_75 = { class: "tw-px-4" }
const _hoisted_76 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5 tw-text-left" }
const _hoisted_77 = {
  key: 0,
  class: "tw-w-full"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PROPERTY", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT PROPERTY", -1)
const _hoisted_80 = ["value"]
const _hoisted_81 = {
  key: 1,
  class: "tw-w-full"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "SCORE CREDIT", -1)
const _hoisted_83 = {
  key: 2,
  class: "tw-w-full"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PROGRAM", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT PROGRAM", -1)
const _hoisted_86 = ["value"]
const _hoisted_87 = { class: "tw-w-full" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "YEARS", -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT YEAR", -1)
const _hoisted_90 = ["value"]
const _hoisted_91 = { class: "tw-flex tw-items-center tw-justify-center tw-mt-5 tw-gap-5 tw-text-left tw-mb-5" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = { class: "tw-mt-4 tw-mb-12" }
const _hoisted_94 = { class: "tw-w-full table-edit" }
const _hoisted_95 = ["colspan"]
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-center tw-text-white tw-text-base tw-py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-[13px]" }, "PERSONAL DATA")
], -1)
const _hoisted_97 = [
  _hoisted_96
]
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " NAME ", -1)
const _hoisted_101 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PHONE NUMBER", -1)
const _hoisted_105 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_106 = { key: 0 }
const _hoisted_107 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " EMAIL", -1)
const _hoisted_109 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_110 = { key: 0 }
const _hoisted_111 = {
  key: 0,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white"
}
const _hoisted_112 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_113 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_114 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTERES RATE", -1)
const _hoisted_116 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_117 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_118 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_119 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_120 = {
  key: 1,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white"
}
const _hoisted_121 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PMI", -1)
const _hoisted_122 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_123 = {
  key: 2,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white"
}
const _hoisted_124 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BACK END RATIO D&I", -1)
const _hoisted_125 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_126 = {
  key: 3,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white"
}
const _hoisted_127 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MAXIMUM LOAN NOT JUMBO", -1)
const _hoisted_128 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_129 = { class: "tw-w-full table-edit tw-shadow-none tw-border-none tw-mt-2" }
const _hoisted_130 = { class: "tw-[&>td]:border-r-0" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("td", { class: "tw-border-none" }, null, -1)
const _hoisted_132 = { class: "tw-border-none tw-px-4" }
const _hoisted_133 = ["onClick"]
const _hoisted_134 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " CUSTOMER INFORMATION ", -1)
const _hoisted_136 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_137 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5" }
const _hoisted_138 = { class: "tw-w-full" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "NAME", -1)
const _hoisted_140 = { class: "tw-w-full" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PHONE NUMBER", -1)
const _hoisted_142 = { class: "tw-w-full" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "EMAIL", -1)
const _hoisted_144 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " PROPERTY INFORMATION ", -1)
const _hoisted_146 = { class: "tw-px-4" }
const _hoisted_147 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_148 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " TYPE OF PROPERTY ", -1)
const _hoisted_150 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_151 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-10" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select", -1)
const _hoisted_153 = ["value"]
const _hoisted_154 = ["value"]
const _hoisted_155 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY ADDRESSES ", -1)
const _hoisted_157 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_158 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " FINANCING INFORMATION ", -1)
const _hoisted_160 = { class: "tw-px-4" }
const _hoisted_161 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_162 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY PRICE ", -1)
const _hoisted_164 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_165 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " DOWN PAYMENT ", -1)
const _hoisted_167 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_168 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN AMOUNT ", -1)
const _hoisted_170 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_171 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_172 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTEREST RATE ", -1)
const _hoisted_173 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_174 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN YEARS ", -1)
const _hoisted_176 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_177 = {
  key: 0,
  class: "tw-even:bg-gray-50 tw-odd:bg-white"
}
const _hoisted_178 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN PROGRAM ", -1)
const _hoisted_179 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_180 = {
  key: 1,
  class: "tw-even:bg-gray-50 tw-odd:bg-white"
}
const _hoisted_181 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PMI ", -1)
const _hoisted_182 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_183 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_184 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY TAXES", -1)
const _hoisted_185 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_186 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY INSURANCE", -1)
const _hoisted_188 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_189 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_190 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FEDERAL TAX", -1)
const _hoisted_191 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_192 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_193 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FLOOD INSURANCE", -1)
const _hoisted_194 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_195 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_196 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ASSOCIATION PAYMENT ", -1)
const _hoisted_197 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_198 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_199 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " OTHERS MONTHLY PAYMENT ", -1)
const _hoisted_200 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_201 = { class: "tw-flex tw-items-center tw-justify-center tw-mt-5 tw-gap-5 tw-text-left tw-mb-8" }
const _hoisted_202 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-px-14" }
const _hoisted_203 = { class: "tw-flex tw-justify-end" }
const _hoisted_204 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_205 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "MONTHLY PAYMENT ", -1)
const _hoisted_206 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_207 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " CLOSING COST, BROKER AND COMMISSIONS ", -1)
const _hoisted_208 = { class: "tw-px-4" }
const _hoisted_209 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_210 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_211 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " CLOSING COST ", -1)
const _hoisted_212 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_213 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_214 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BROKER PAYMENT ", -1)
const _hoisted_215 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_216 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_217 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " INCOME ", -1)
const _hoisted_218 = { class: "tw-px-4" }
const _hoisted_219 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_220 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_221 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MONTHLY PERCENTAGE OCCUPANCY % ", -1)
const _hoisted_222 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_223 = { class: "tw-flex tw-items-center justify-content-center" }
const _hoisted_224 = /*#__PURE__*/_createElementVNode("span", null, "%", -1)
const _hoisted_225 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_226 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PRICE RENT FOR DAY $ ", -1)
const _hoisted_227 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_228 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_229 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ESTIMATE MONTHLY INCOME ", -1)
const _hoisted_230 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_231 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_232 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-3 tw-gap-5" }
const _hoisted_233 = { class: "text-center" }
const _hoisted_234 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "ESTIMATE CAPITAL GAIN OR PLUSVALIA", -1)
const _hoisted_235 = ["value"]
const _hoisted_236 = { class: "tw-flex tw-justify-center tw-gap-[20px] tw-pb-5" }
const _hoisted_237 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_238 = { class: "tw-flex tw-justify-end" }
const _hoisted_239 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_240 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "TOTAL INVESTMENT ", -1)
const _hoisted_241 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_242 = { class: "tw-flex tw-justify-end" }
const _hoisted_243 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_244 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " NET PROFIT 5 YEARS (%) ", -1)
const _hoisted_245 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }
const _hoisted_246 = ["disabled"]
const _hoisted_247 = {
  class: "modal fade modal-xl",
  id: "exampleModalEscenarioShortTerm",
  tabindex: "-1",
  "aria-labelledby": "exampleModalEscenarioShortTerm",
  "aria-hidden": "true"
}
const _hoisted_248 = { class: "modal-dialog" }
const _hoisted_249 = { class: "modal-content" }
const _hoisted_250 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_251 = { class: "modal-body" }
const _hoisted_252 = { class: "tw-flex tw-justify-end tw-gap-[40px] tw-pr-7" }
const _hoisted_253 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_254 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print tw-text-[#FFFFFF] tw-pr-2" }, null, -1)
const _hoisted_255 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_256 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope tw-text-[#FFFFFF] tw-text-[18px] tw-pr-2" }, null, -1)
const _hoisted_257 = /*#__PURE__*/_createElementVNode("section", { slot: "pdf-content" }, null, -1)
const _hoisted_258 = {
  class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-",
  id: "printable-target"
}
const _hoisted_259 = /*#__PURE__*/_createElementVNode("h1", { class: "pb-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("SHORT TERM FINANCING"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" PROFIT OF ESTIMATED COST/BENEFITS")
  ])
], -1)
const _hoisted_260 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_261 = {
  key: 0,
  class: "tw-flex tw-justify-start gap-3 tw-w-full"
}
const _hoisted_262 = { class: "table-mlo w-100 bg-white rounded-4" }
const _hoisted_263 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_264 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "MORTGAGE LOAN ORIGINATOR")
  ])
], -1)
const _hoisted_265 = { class: "data" }
const _hoisted_266 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY", -1)
const _hoisted_267 = { class: "data" }
const _hoisted_268 = /*#__PURE__*/_createElementVNode("td", null, "SCORE-CREDIT", -1)
const _hoisted_269 = { class: "data" }
const _hoisted_270 = /*#__PURE__*/_createElementVNode("td", null, "PROGRAM", -1)
const _hoisted_271 = { class: "data" }
const _hoisted_272 = /*#__PURE__*/_createElementVNode("td", null, "YEARS", -1)
const _hoisted_273 = { class: "data" }
const _hoisted_274 = /*#__PURE__*/_createElementVNode("td", null, "NAME", -1)
const _hoisted_275 = { class: "data" }
const _hoisted_276 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER-MLO", -1)
const _hoisted_277 = { class: "data" }
const _hoisted_278 = /*#__PURE__*/_createElementVNode("td", null, "FHA", -1)
const _hoisted_279 = { class: "data" }
const _hoisted_280 = /*#__PURE__*/_createElementVNode("td", null, "INTEREST-RATE", -1)
const _hoisted_281 = { class: "data" }
const _hoisted_282 = /*#__PURE__*/_createElementVNode("td", null, "MINUMUM-DOWN-PAYMENT-LOWER", -1)
const _hoisted_283 = { class: "data" }
const _hoisted_284 = /*#__PURE__*/_createElementVNode("td", null, "MINUMUM-DOWN-PAYMENT-HIGHER", -1)
const _hoisted_285 = { class: "data" }
const _hoisted_286 = /*#__PURE__*/_createElementVNode("td", null, "PMI", -1)
const _hoisted_287 = { class: "data" }
const _hoisted_288 = /*#__PURE__*/_createElementVNode("td", null, "BACK-END-RATIO-D&I", -1)
const _hoisted_289 = { class: "data" }
const _hoisted_290 = /*#__PURE__*/_createElementVNode("td", null, "MAXIMUM-LOAN-NOT-JUMBO", -1)
const _hoisted_291 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_292 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "CUSTOMER INFORMATION")
  ])
], -1)
const _hoisted_293 = { class: "data" }
const _hoisted_294 = /*#__PURE__*/_createElementVNode("td", null, "NAME", -1)
const _hoisted_295 = { class: "data" }
const _hoisted_296 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER", -1)
const _hoisted_297 = { class: "data" }
const _hoisted_298 = /*#__PURE__*/_createElementVNode("td", null, "EMAIL", -1)
const _hoisted_299 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_300 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "PROPERTY INFORMATION")
  ])
], -1)
const _hoisted_301 = { class: "data" }
const _hoisted_302 = /*#__PURE__*/_createElementVNode("td", null, "TYPE-OF-PROPERTY", -1)
const _hoisted_303 = { class: "data" }
const _hoisted_304 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-ADDRESSES", -1)
const _hoisted_305 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_306 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "FINANCIAL-INFORMATION")
  ])
], -1)
const _hoisted_307 = { class: "data" }
const _hoisted_308 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-PRICE", -1)
const _hoisted_309 = { class: "data" }
const _hoisted_310 = /*#__PURE__*/_createElementVNode("td", null, "DOWN-PAYMENT", -1)
const _hoisted_311 = { class: "data" }
const _hoisted_312 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-AMOUNT", -1)
const _hoisted_313 = { class: "data" }
const _hoisted_314 = /*#__PURE__*/_createElementVNode("td", null, "INTEREST-RATE", -1)
const _hoisted_315 = { class: "data" }
const _hoisted_316 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-YEARS", -1)
const _hoisted_317 = { class: "data" }
const _hoisted_318 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-PROGRAM", -1)
const _hoisted_319 = { class: "data" }
const _hoisted_320 = /*#__PURE__*/_createElementVNode("td", null, "PMI-OR-MIP", -1)
const _hoisted_321 = { class: "data" }
const _hoisted_322 = /*#__PURE__*/_createElementVNode("td", null, "MONTHLY-PAYMENT", -1)
const _hoisted_323 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_324 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "CLOSING COST, BROKER AND COMMISSIONS ")
  ])
], -1)
const _hoisted_325 = { class: "data" }
const _hoisted_326 = /*#__PURE__*/_createElementVNode("td", null, "CLOSING-COST", -1)
const _hoisted_327 = { class: "data" }
const _hoisted_328 = /*#__PURE__*/_createElementVNode("td", null, "BROKER-PAYMENT", -1)
const _hoisted_329 = { class: "table table-bordered border-0 mb-3 table-edit table-no-radius" }
const _hoisted_330 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "table-no-radius",
      scope: "col",
      colspan: "2"
    }, "INCOME")
  ])
], -1)
const _hoisted_331 = { class: "data" }
const _hoisted_332 = /*#__PURE__*/_createElementVNode("td", null, "MONTHLY-PERCENTAGE-OCCUPANCY %", -1)
const _hoisted_333 = { class: "data" }
const _hoisted_334 = /*#__PURE__*/_createElementVNode("td", null, "PRICE-RENT-FOR-DAY $", -1)
const _hoisted_335 = { class: "data" }
const _hoisted_336 = /*#__PURE__*/_createElementVNode("td", null, "ESTIMATE-MONTHLY-INCOME", -1)
const _hoisted_337 = { class: "data" }
const _hoisted_338 = /*#__PURE__*/_createElementVNode("td", null, "ESTIMATE-CAPITAL-GAIN-OR-PLUSVALIA (%)", -1)
const _hoisted_339 = { class: "data" }
const _hoisted_340 = /*#__PURE__*/_createElementVNode("td", null, "AMORTIZATION-OF-DEBIT-CAPITAL-(CAPITALIZATION)", -1)
const _hoisted_341 = /*#__PURE__*/_createElementVNode("div", { class: "px-5 pb-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-font-medium tw-text-[18px]" }, "Note:"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" The investment outcome presented here is an estimate subject to potential "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" fluctuations arising from the execution of the project. ")
  ])
], -1)
const _hoisted_342 = {
  class: "modal fade",
  id: "exampleModalMessage",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_343 = { class: "modal-dialog" }
const _hoisted_344 = { class: "content-mensage modal-content tw-bg-[#E6E7E8]" }
const _hoisted_345 = /*#__PURE__*/_createElementVNode("div", { class: "boton-mensage modal-header tw-flex tw-items-center tw-outline-none tw-bg-[#00a0da] tw-border-[#00a0da] tw-bordered-[20px]" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title tw-text-white tw-text-xl",
    id: "exampleModalLabel"
  }, "New Message"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle tw-text-[25px] tw-text-white" })
  ])
], -1)
const _hoisted_346 = { class: "modal-body" }
const _hoisted_347 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_348 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "USER-EMAIL: ", -1)
const _hoisted_349 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_350 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "SUBJECT: ", -1)
const _hoisted_351 = { class: "tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center" }
const _hoisted_352 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pl-5" }, null, -1)
const _hoisted_353 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_354 = { class: "tw-flex tw-justify-start tw-items-center" }
const _hoisted_355 = {
  key: 0,
  class: "btn-attach tw-bg-[#E6E7E8] tw-h-[40px] tw-font-bold tw-px-4 tw-rounded-full tw-text-xl"
}
const _hoisted_356 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip tw-text-gray-500" }, null, -1)
const _hoisted_357 = { class: "tw-flex tw-justify-end tw-items-center" }
const _hoisted_358 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_ResidentialView = _resolveComponent("ResidentialView")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_VueNumberFormat = _resolveComponent("VueNumberFormat")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.header === null)
        ? (_openBlock(), _createBlock(_component_TopBar, {
            key: 0,
            helpBar: true,
            helpDescription: "Video tutorial for the use of the ''SHORT TERM FINANCING''",
            helpVideo: "https://www.realtortools.org/media/Video%20Short%20Term%20Financing.mp4"
          }))
        : _createCommentVNode("", true),
      (!_ctx.foreign)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_ResidentialView, {
              header: false,
              onRealtorEvent: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeRealtor($event)))
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.foreign)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    id: "openNoteModal1",
                    class: "btn tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold btn-sm",
                    style: {"border":"none"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleComment && _ctx.toggleComment(...args)))
                  }, " SEE NOTE "),
                  (_ctx.isCommentVisible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createTextVNode(" You can find the Economic Sheet by: Name, Phone Number, or Date."),
                        _hoisted_11,
                        _createTextVNode("Then, to filter, click on "),
                        _hoisted_12,
                        _createTextVNode(" On the new screen, click on "),
                        _hoisted_13
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_14
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.scenario.users)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _withDirectives(_createElementVNode("input", {
                            name: "",
                            id: "",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.scenario.users.name) = $event)),
                            class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                          }, null, 512), [
                            [_vModelText, _ctx.params.scenario.users.name]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _withDirectives(_createElementVNode("input", {
                            name: "",
                            id: "",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.scenario.users.phonenumber) = $event)),
                            class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                          }, null, 512), [
                            [_vModelText, _ctx.params.scenario.users.phonenumber]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode(_component_datepicker, {
                            "auto-apply": "",
                            class: "w-100",
                            range: "",
                            modelValue: _ctx.configDatePicker.date,
                            "onUpdate:modelValue": [
                              _cache[4] || (_cache[4] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
                              _ctx.changeDate
                            ],
                            placeholder: "Enter date range..."
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getScenarioUsers())),
                        class: "mb-3 tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]"
                      }, "Filter"),
                      _createElementVNode("table", _hoisted_24, [
                        _hoisted_25,
                        (_ctx.scenario.users.results.length > 0)
                          ? (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.users.results, (user) => {
                                return (_openBlock(), _createElementBlock("tr", null, [
                                  _createElementVNode("td", null, _toDisplayString(user.user_name), 1),
                                  _createElementVNode("td", null, _toDisplayString(user.user_email), 1),
                                  _createElementVNode("td", null, _toDisplayString(user.user_phonenumber), 1),
                                  _createElementVNode("td", null, _toDisplayString(user.create_date), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("a", {
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#exampleModal4858",
                                      href: "#",
                                      onClick: ($event: any) => (_ctx.loadScenarios(user))
                                    }, _hoisted_29, 8, _hoisted_27)
                                  ])
                                ]))
                              }), 256))
                            ]))
                          : (_openBlock(), _createElementBlock("tbody", _hoisted_30, _hoisted_32))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      (_ctx.scenario.userScenarios)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("table", _hoisted_42, [
                              _hoisted_43,
                              (_ctx.scenario.userScenarios.results && _ctx.scenario.userScenarios.results.length > 0)
                                ? (_openBlock(), _createElementBlock("tbody", _hoisted_44, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.userScenarios.results, (userscenario) => {
                                      return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", null, _toDisplayString(userscenario.code), 1),
                                        _createElementVNode("td", null, _toDisplayString(userscenario.date), 1),
                                        _createElementVNode("td", null, _toDisplayString(userscenario.type), 1),
                                        _createElementVNode("td", null, _toDisplayString(userscenario.type_name), 1),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("a", {
                                            "data-bs-toggle": "modal",
                                            "data-bs-target": "#exampleModalEscenarioShortTerm",
                                            href: "#",
                                            onClick: ($event: any) => (_ctx.loadScenario(userscenario))
                                          }, _hoisted_47, 8, _hoisted_45)
                                        ])
                                      ]))
                                    }), 256))
                                  ]))
                                : (_openBlock(), _createElementBlock("tbody", _hoisted_48, _hoisted_50))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("div", _hoisted_56, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTitleCompanies, (user) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", null, _toDisplayString(user.companyname), 1),
                          _createTextVNode(),
                          _hoisted_60
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("table", _hoisted_62, [
                          _hoisted_63,
                          _createElementVNode("tbody", null, [
                            (user.tables[0] !== undefined)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_64, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.tables[0].tabledata[0].data, (tabledata) => {
                                    return (_openBlock(), _createElementBlock("td", null, _toDisplayString(tabledata.table_closing_close) + "%", 1))
                                  }), 256)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.tables[0].tabledata[1].data, (tabledata) => {
                                    return (_openBlock(), _createElementBlock("td", null, _toDisplayString(tabledata.table_each_tittle_review), 1))
                                  }), 256))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("button", {
                          class: "tw-bg-[#00a0da] tw-px-11 tw-mt-4 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]",
                          onClick: ($event: any) => (_ctx.getItTitleCompany(user))
                        }, "GET IT", 8, _hoisted_65)
                      ])
                    ])
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _hoisted_67,
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listInspectors, (user) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createElementVNode("span", null, _toDisplayString(user.username + " " + user.lastname), 1),
                        _createTextVNode(),
                        _hoisted_71,
                        _hoisted_72
                      ]))
                    }), 256))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _hoisted_74,
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("div", _hoisted_76, [
                (!_ctx.foreign)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                      _hoisted_78,
                      _withDirectives(_createElementVNode("select", {
                        name: "",
                        id: "",
                        class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.property) = $event))
                      }, [
                        _hoisted_79,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTablePropertiesMlo, (tabletype) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: tabletype.id
                          }, _toDisplayString(tabletype.name), 9, _hoisted_80))
                        }), 256))
                      ], 512), [
                        [_vModelSelect, _ctx.filters.property]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.foreign)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                      _hoisted_82,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.score) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.filters.score]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.foreign)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                      _hoisted_84,
                      _withDirectives(_createElementVNode("select", {
                        name: "",
                        id: "",
                        class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.program) = $event))
                      }, [
                        _hoisted_85,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPrograms, (program) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (program.name == 'CONVENTIONAL')
                              ? (_openBlock(), _createElementBlock("option", {
                                  key: 0,
                                  value: program.id
                                }, _toDisplayString(program.name), 9, _hoisted_86))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ], 512), [
                        [_vModelSelect, _ctx.filters.program]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_87, [
                  _hoisted_88,
                  _withDirectives(_createElementVNode("select", {
                    name: "",
                    id: "",
                    class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.year) = $event))
                  }, [
                    _hoisted_89,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listYears, (year) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: year.id
                      }, _toDisplayString(year.name), 9, _hoisted_90))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.filters.year]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("button", {
                  class: "tw-bg-[#00a0da] disabled:tw-bg-[#ccc] tw-px-11 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[200px]",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.filterTable && _ctx.filterTable(...args))),
                  disabled: _ctx.listMlos.length == 0
                }, "RUN", 8, _hoisted_92)
              ]),
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("table", _hoisted_94, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        class: "tw-bg-[#00a0da] tw-rounded-tl-2xl tw-rounded-tr-2xl",
                        colspan: _ctx.listMlos.length + 1
                      }, _hoisted_97, 8, _hoisted_95)
                    ])
                  ]),
                  (_ctx.listMlos.length > 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_98, [
                        _createElementVNode("tr", _hoisted_99, [
                          _hoisted_100,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_101, [
                              (_ctx.filters.active)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString(user.username +
                                                " " + user.lastname), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 256))
                        ]),
                        _createElementVNode("tr", _hoisted_103, [
                          _hoisted_104,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_105, [
                              (_ctx.filters.active)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_106, _toDisplayString(user.phonenumber), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 256))
                        ]),
                        _createElementVNode("tr", _hoisted_107, [
                          _hoisted_108,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_109, [
                              (_ctx.filters.active)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_110, _toDisplayString(user.email), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 256))
                        ]),
                        (!_ctx.foreign)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_111, [
                              _createElementVNode("td", _hoisted_112, _toDisplayString(_ctx.filters.program_name), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                                return (_openBlock(), _createElementBlock("td", _hoisted_113, _toDisplayString(user.fha), 1))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("tr", _hoisted_114, [
                          _hoisted_115,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_116, _toDisplayString(user.interes_rate && user.interes_rate != "-" ?
                                                user.interes_rate + "%" : "-"), 1))
                          }), 256))
                        ]),
                        _createElementVNode("tr", _hoisted_117, [
                          _createElementVNode("td", _hoisted_118, _toDisplayString(_ctx.foreign ? "DOWN PAYMENT" : "MINIMUM DOWN PAYMENT"), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_119, _toDisplayString(user.minimum_down_payment &&
                                                user.minimum_down_payment != "-" ? user.minimum_down_payment + "%" : "-"), 1))
                          }), 256))
                        ]),
                        (!_ctx.foreign)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_120, [
                              _hoisted_121,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                                return (_openBlock(), _createElementBlock("td", _hoisted_122, _toDisplayString(user.average_mip_pmi), 1))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.foreign)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_123, [
                              _hoisted_124,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                                return (_openBlock(), _createElementBlock("td", _hoisted_125, _toDisplayString(user.backend_ratio), 1))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.foreign)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_126, [
                              _hoisted_127,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                                return (_openBlock(), _createElementBlock("td", _hoisted_128, _toDisplayString(user.maximum_loan ? ('' + _ctx.commaFormat(user.maximum_loan)) : ''), 1))
                              }), 256))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("table", _hoisted_129, [
                  _createElementVNode("tr", _hoisted_130, [
                    _hoisted_131,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMlos, (user) => {
                      return (_openBlock(), _createElementBlock("td", _hoisted_132, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.loadData(user)),
                          class: "tw-bg-[#00a0da] tw-px-11 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-mt-5"
                        }, "GET IT", 8, _hoisted_133)
                      ]))
                    }), 256))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_134, [
            _hoisted_135,
            _createElementVNode("div", _hoisted_136, [
              _createElementVNode("div", _hoisted_137, [
                _createElementVNode("div", _hoisted_138, [
                  _hoisted_139,
                  _withDirectives(_createElementVNode("input", {
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.customer.name) = $event)),
                    placeholder: "Complete name",
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 512), [
                    [_vModelText, _ctx.customer.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_140, [
                  _hoisted_141,
                  _withDirectives(_createElementVNode("input", {
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.customer.phone) = $event)),
                    placeholder: "9999999999",
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 512), [
                    [_vModelText, _ctx.customer.phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_142, [
                  _hoisted_143,
                  _withDirectives(_createElementVNode("input", {
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.customer.email) = $event)),
                    placeholder: "example@gmail.com",
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 512), [
                    [_vModelText, _ctx.customer.email]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_144, [
            _hoisted_145,
            _createElementVNode("div", _hoisted_146, [
              _createElementVNode("table", _hoisted_147, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_148, [
                    _hoisted_149,
                    _createElementVNode("td", _hoisted_150, [
                      _createElementVNode("div", _hoisted_151, [
                        _withDirectives(_createElementVNode("select", {
                          name: "",
                          id: "",
                          class: "form-control tw-full",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.financialInformation.propertyType) = $event)),
                          onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.calculatePropertyEstimateCapitalGain && _ctx.calculatePropertyEstimateCapitalGain(...args)))
                        }, [
                          _hoisted_152,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPropertyTypes, (property) => {
                            return (_openBlock(), _createElementBlock("option", { value: property }, _toDisplayString(property.name), 9, _hoisted_153))
                          }), 256))
                        ], 544), [
                          [_vModelSelect, _ctx.financialInformation.propertyType]
                        ]),
                        (_ctx.financialInformation.propertyType)
                          ? (_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "text",
                              value: (_ctx.financialInformation.propertyType.text ? (_ctx.financialInformation.propertyType.text * 100) + '%' : ''),
                              disabled: ""
                            }, null, 8, _hoisted_154))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_155, [
                    _hoisted_156,
                    _createElementVNode("td", _hoisted_157, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.financialInformation.propertyAddresses) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.financialInformation.propertyAddresses]
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_158, [
            _hoisted_159,
            _createElementVNode("div", _hoisted_160, [
              _createElementVNode("table", _hoisted_161, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_162, [
                    _hoisted_163,
                    _createElementVNode("td", _hoisted_164, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyPrice",
                        value: _ctx.financialInformation.propertyPrice,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.financialInformation.propertyPrice) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' },
                        onChange: _ctx.calculatePropertyEstimateCapitalGain
                      }, null, 8, ["value", "options", "onChange"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_165, [
                    _hoisted_166,
                    _createElementVNode("td", _hoisted_167, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyDownPayment",
                        value: _ctx.financialInformation.propertyDownPayment,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.financialInformation.propertyDownPayment) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_168, [
                    _hoisted_169,
                    _createElementVNode("td", _hoisted_170, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyEstimateLoan",
                        value: _ctx.financialInformation.propertyEstimateLoan,
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.financialInformation.propertyEstimateLoan) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: true, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_171, [
                    _hoisted_172,
                    _createElementVNode("td", _hoisted_173, _toDisplayString(_ctx.selection.selectedUser ? _ctx.selection.selectedUser.interes_rate : ''), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_174, [
                    _hoisted_175,
                    _createElementVNode("td", _hoisted_176, _toDisplayString(_ctx.selection.selectedYears ? _ctx.selection.selectedYears.name : ''), 1)
                  ]),
                  (!_ctx.foreign)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_177, [
                        _hoisted_178,
                        _createElementVNode("td", _hoisted_179, _toDisplayString(_ctx.selection.selectedProgram ? _ctx.selection.selectedProgram.name : ''), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.foreign)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_180, [
                        _hoisted_181,
                        _createElementVNode("td", _hoisted_182, " $ " + _toDisplayString(_ctx.pmi !== null ? Math.round(_ctx.pmi).toLocaleString() : ''), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", _hoisted_183, [
                    _hoisted_184,
                    _createElementVNode("td", _hoisted_185, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "monthlypayment",
                        value: _ctx.propertyTaxes,
                        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.propertyTaxes) = $event)),
                        options: {
                                            precision: 0,
                                            prefix: '$ ',
                                            thousand: ',',
                                            acceptNegative: true,
                                            isInteger: false,
                                            decimal: '.',
                                        }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_186, [
                    _hoisted_187,
                    _createElementVNode("td", _hoisted_188, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "monthlypayment",
                        value: _ctx.propertyInsurance,
                        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.propertyInsurance) = $event)),
                        options: {
                                            precision: 0,
                                            prefix: '$ ',
                                            thousand: ',',
                                            acceptNegative: true,
                                            isInteger: false,
                                            decimal: '.',
                                        }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_189, [
                    _hoisted_190,
                    _createElementVNode("td", _hoisted_191, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "monthlypayment",
                        value: _ctx.federalTaxes,
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.federalTaxes) = $event)),
                        options: {
                                            precision: 0,
                                            prefix: '$ ',
                                            thousand: ',',
                                            acceptNegative: true,
                                            isInteger: false,
                                            decimal: '.',
                                        }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_192, [
                    _hoisted_193,
                    _createElementVNode("td", _hoisted_194, _toDisplayString(_ctx.financialInformation.propertyFloodInsurance?.value !== undefined
                                                ? '$' + _ctx.commaFormat(_ctx.financialInformation.propertyFloodInsurance?.value)
                                                : ''), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_195, [
                    _hoisted_196,
                    _createElementVNode("td", _hoisted_197, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "association",
                        value: _ctx.financialInformation.association,
                        "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.financialInformation.association) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_198, [
                    _hoisted_199,
                    _createElementVNode("td", _hoisted_200, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "otherMontlhyPayment",
                        value: _ctx.financialInformation.otherMontlhyPayment,
                        "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.financialInformation.otherMontlhyPayment) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_201, [
            _createElementVNode("div", _hoisted_202, [
              _createElementVNode("div", _hoisted_203, [
                _createElementVNode("div", _hoisted_204, [
                  _hoisted_205,
                  _createVNode(_component_VueNumberFormat, {
                    id: "association",
                    value: _ctx.totalMonthly,
                    "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.totalMonthly) = $event)),
                    options: {
                                    precision: 0,
                                    prefix: '$ ',
                                    thousand: ',',
                                    acceptNegative: false,
                                    isInteger: false,
                                    decimal: '.',
                                },
                    class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                  }, null, 8, ["value", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_206, [
            _hoisted_207,
            _createElementVNode("div", _hoisted_208, [
              _createElementVNode("table", _hoisted_209, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_210, [
                    _hoisted_211,
                    _createElementVNode("td", _hoisted_212, _toDisplayString(_ctx.financialInformation.propertyClosingCostBuy?.text !== undefined
                                                ? '$' + _ctx.commaFormat(_ctx.financialInformation.propertyClosingCostBuy?.text)
                                                : ''), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_213, [
                    _hoisted_214,
                    _createElementVNode("td", _hoisted_215, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyBrokerPayment",
                        value: _ctx.financialInformation.propertyBrokerPayment,
                        "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.financialInformation.propertyBrokerPayment) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_216, [
            _hoisted_217,
            _createElementVNode("div", _hoisted_218, [
              _createElementVNode("table", _hoisted_219, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_220, [
                    _hoisted_221,
                    _createElementVNode("td", _hoisted_222, [
                      _createElementVNode("div", _hoisted_223, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.financialInformation.propertyMonthlyPercentageOccupancy) = $event)),
                          onInput: _cache[28] || (_cache[28] = ($event: any) => (_ctx.calculateProperty('monthlypercentageoccupancy')))
                        }, null, 544), [
                          [_vModelText, _ctx.financialInformation.propertyMonthlyPercentageOccupancy]
                        ]),
                        _hoisted_224
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_225, [
                    _hoisted_226,
                    _createElementVNode("td", _hoisted_227, [
                      _createElementVNode("div", {
                        onInput: _cache[30] || (_cache[30] = ($event: any) => (_ctx.calculateProperty('estimatemonthlyincome')))
                      }, [
                        _createVNode(_component_VueNumberFormat, {
                          id: "propertyRentDay",
                          value: _ctx.financialInformation.propertyRentDay,
                          "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.financialInformation.propertyRentDay) = $event)),
                          options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: true, isInteger: true, decimal: '.' }
                        }, null, 8, ["value", "options"])
                      ], 32)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_228, [
                    _hoisted_229,
                    _createElementVNode("td", _hoisted_230, [
                      _createVNode(_component_VueNumberFormat, {
                        id: "propertyEstimateMonthlyIncome",
                        value: _ctx.financialInformation.propertyEstimateMonthlyIncome,
                        "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.financialInformation.propertyEstimateMonthlyIncome) = $event)),
                        disabled: "",
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: false, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_231, [
              _createElementVNode("div", _hoisted_232, [
                _createElementVNode("div", _hoisted_233, [
                  _hoisted_234,
                  _createElementVNode("input", {
                    name: "",
                    id: "",
                    type: "text",
                    disabled: "",
                    value: _ctx.financialInformation.propertyEstimateCapitalGainPlusvalia ? (_ctx.financialInformation.propertyEstimateCapitalGainPlusvalia * 100)  : '',
                    class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                  }, null, 8, _hoisted_235)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_236, [
            _createElementVNode("div", _hoisted_237, [
              _createElementVNode("div", _hoisted_238, [
                _createElementVNode("div", _hoisted_239, [
                  _hoisted_240,
                  _createVNode(_component_VueNumberFormat, {
                    id: "totalInversment",
                    value: _ctx.totalInversment,
                    "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.totalInversment) = $event)),
                    disabled: "",
                    class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3",
                    options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: false, decimal: '.' }
                  }, null, 8, ["value", "options"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_241, [
              _createElementVNode("div", _hoisted_242, [
                _createElementVNode("div", _hoisted_243, [
                  _hoisted_244,
                  _createVNode(_component_VueNumberFormat, {
                    id: "netProfitPercent",
                    value: _ctx.netProfitPercent,
                    "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.netProfitPercent) = $event)),
                    disabled: "",
                    class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3",
                    options: { precision: 0, suffix: '% ', prefix: '', thousand: ',', acceptNegative: false, isInteger: false, decimal: '.' }
                  }, null, 8, ["value", "options"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_245, [
            _createElementVNode("button", {
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.submitScenario($event))),
              disabled: !_ctx.scenarioValid,
              class: "tw-bg-[#78c18a] disabled:tw-bg-[#ccc] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
            }, "SAVE & REGISTER", 8, _hoisted_246)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_247, [
      _createElementVNode("div", _hoisted_248, [
        _createElementVNode("div", _hoisted_249, [
          _hoisted_250,
          _createElementVNode("div", _hoisted_251, [
            _createElementVNode("div", _hoisted_252, [
              _createElementVNode("div", _hoisted_253, [
                _createElementVNode("button", {
                  onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.printScenario())),
                  class: "block"
                }, [
                  _hoisted_254,
                  _createTextVNode("PRINT")
                ])
              ]),
              _createElementVNode("div", _hoisted_255, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.generateMail()))
                }, [
                  _hoisted_256,
                  _createTextVNode("SEND")
                ]),
                _createVNode(_component_vue3_html2pdf, {
                  "show-layout": false,
                  "float-layout": true,
                  "enable-download": false,
                  "preview-modal": false,
                  "pdf-quality": 2,
                  "pdf-format": "a4",
                  "pdf-content-width": "800px",
                  "manual-pagination": true,
                  onBeforeDownload: _cache[37] || (_cache[37] = ($event: any) => (_ctx.beforeFileGenerated($event))),
                  ref: "html2Pdf"
                }, {
                  default: _withCtx(() => [
                    _hoisted_257
                  ]),
                  _: 1
                }, 512)
              ])
            ]),
            _createElementVNode("div", _hoisted_258, [
              _hoisted_259,
              _createElementVNode("div", _hoisted_260, [
                (_ctx.scenario.scenarioData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_261, [
                      _createElementVNode("div", _hoisted_262, [
                        _createElementVNode("table", _hoisted_263, [
                          _hoisted_264,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_265, [
                              _hoisted_266,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedProperty.name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_267, [
                              _hoisted_268,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.filters.score), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_269, [
                              _hoisted_270,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.filters.program_name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_271, [
                              _hoisted_272,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedYears.name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_273, [
                              _hoisted_274,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.username), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_275, [
                              _hoisted_276,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.phonenumber), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_277, [
                              _hoisted_278,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedProgram.name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_279, [
                              _hoisted_280,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.interes_rate), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_281, [
                              _hoisted_282,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.minimum_down_paymentlower), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_283, [
                              _hoisted_284,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.minimum_down_paymenthigher), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_285, [
                              _hoisted_286,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.average_mip_pmi), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_287, [
                              _hoisted_288,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.backend_ratio), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_289, [
                              _hoisted_290,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedUser.maximum_loan), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_291, [
                          _hoisted_292,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_293, [
                              _hoisted_294,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_295, [
                              _hoisted_296,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_phonenumber), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_297, [
                              _hoisted_298,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_email), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_299, [
                          _hoisted_300,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_301, [
                              _hoisted_302,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyType.name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_303, [
                              _hoisted_304,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAddresses), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_305, [
                          _hoisted_306,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_307, [
                              _hoisted_308,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyPrice), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_309, [
                              _hoisted_310,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyDownPayment), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_311, [
                              _hoisted_312,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyEstimateLoan), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_313, [
                              _hoisted_314,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyInterestRate) + "% ", 1)
                            ]),
                            _createElementVNode("tr", _hoisted_315, [
                              _hoisted_316,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedYears.name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_317, [
                              _hoisted_318,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.selectedProgram.name), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_319, [
                              _hoisted_320,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyPmiMip), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_321, [
                              _hoisted_322,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyMonthlyPayment), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_323, [
                          _hoisted_324,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_325, [
                              _hoisted_326,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyClosingCostBuy?.text), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_327, [
                              _hoisted_328,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyBrokerPayment), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_329, [
                          _hoisted_330,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_331, [
                              _hoisted_332,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyMonthlyPercentageOccupancy), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_333, [
                              _hoisted_334,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyRentDay), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_335, [
                              _hoisted_336,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyEstimateMonthlyIncome), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_337, [
                              _hoisted_338,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyEstimateCapitalGainPlusvalia), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_339, [
                              _hoisted_340,
                              _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyAmortizationOfDebtCapital), 1)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _hoisted_341
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_342, [
      _createElementVNode("div", _hoisted_343, [
        _createElementVNode("div", _hoisted_344, [
          _hoisted_345,
          _createElementVNode("div", _hoisted_346, [
            _createElementVNode("div", _hoisted_347, [
              _hoisted_348,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.scenarioMail.email) = $event)),
                class: "tw-w-full tw-h-[32px]",
                style: {"padding-left":"10px"}
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_349, [
              _hoisted_350,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.scenarioMail.subject) = $event)),
                class: "tw-w-full tw-h-[32px]",
                style: {"padding-left":"10px"}
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.subject]
              ])
            ]),
            _createElementVNode("div", _hoisted_351, [
              _withDirectives(_createElementVNode("textarea", {
                name: "",
                id: "",
                cols: "53",
                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.scenarioMail.message) = $event)),
                rows: "9"
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.message]
              ])
            ])
          ]),
          _hoisted_352,
          _createElementVNode("div", _hoisted_353, [
            _createElementVNode("div", _hoisted_354, [
              (_ctx.scenarioMail.file)
                ? (_openBlock(), _createElementBlock("button", _hoisted_355, [
                    _hoisted_356,
                    _createTextVNode(" " + _toDisplayString(_ctx.scenarioMail.file.name), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_357, [
              _createElementVNode("button", {
                "data-bs-dismiss": "modal",
                class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl",
                disabled: _ctx.v$.scenarioMail.$invalid,
                onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.sendScenarioMail && _ctx.sendScenarioMail(...args)))
              }, "SEND MESSAGE", 8, _hoisted_358)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}